<template>
<div>
  <div class="row" style="height: 60px"></div>
  <div class="row titleRow">
    <div class="col">
      <h1>{{$t('offers.title')}}</h1>
    </div>
  </div>
  <div v-show="commitments" class="row separatedRow">
    <div v-if="commitments.length > 1" class="col">
      <p> {{$t('offers.commitment')}}</p>
      <div class="row" style="max-width: 500px;margin-left: auto;margin-right: auto;">
        <div v-for="(commitment, index) in commitments" :key="index" class="col">
          <button :class="'btn btn-secondary targetButton ' + ((commitmentChoice === commitment.duration) ? 'bg-color' : '')" @click="commitmentChoice=commitment.duration">{{commitment.name}}</button>
        </div>
      </div>
    </div>
  </div>
  <div class="row separatedRow">
    <div v-for="(offer, index) in offers" :key="index" :class="'col clickableItem offer ' + ((selectedOffer === offer) ? 'bg-color' : '')"  @click="selectOffer(offer)" :style="'background-color: rgba(200, 200, 200, '+(index+1)/offers.length+')'">
      <div style="padding-bottom: 48px;">
      <div class="row" style="height: 60px"></div>
      <div class="row">
        <div class="col">
          <h1 style="text-align: center;">{{offer.name}}</h1>
        </div>
      </div>
      <div class="row separatedRow">
        <div v-if="commitments.length === 0" class="col">
          {{offer.commitment.duration}} {{getPeriodTranslation(offer.commitment.period, offer.commitment.duration).toLowerCase()}}
        </div>
        <div v-else-if="commitments.length === 1" class="col">
          {{ commitments[0].duration + ' ' + $t('config.commitments.month').toLowerCase() }}
        </div>
        <div v-else class="col">
          {{commitmentChoice + ' ' + $t('config.commitments.month').toLowerCase() }}
        </div>
        </div>
          <div class="row separatedRow">
            <div class="col">
              <div v-for="(option, i) in offer.options" :key="i" class="row">
                <div class="col">
                  <span :class="(option.active) ? 'active' : 'inactive'">{{ returnOptionOrFalse(option.id) ? returnOptionOrFalse(option.id) : '' }}</span>
                </div>
              </div>
            </div>
          </div>
      </div>
      <div class="offerPrices" v-if="getInitialPrice(offer) && getRecurrentPrice(offer)">
        <div class="row">
          <div class="col">
            {{$t('offers.starterPack')}} : {{ getInitialPrice(offer) }} <span v-html="currency"></span>
          </div>
        </div>
        <div class="row">
          <div class="col">
            {{ getRecurrentPrice(offer) }} <span v-html="currency"></span> / {{getPeriodTranslation(offer.recurrentTime, 1).toLowerCase()}}
          </div>
        </div>
      </div>
      <div class="offerPrices" v-if="!getInitialPrice(offer) || !getRecurrentPrice(offer)">
        {{$t('offers.disable')}}
      </div>
    </div>
    </div>
      <div class="row">
        <div class="col overFooter">
          <button type="submit" :class="'btn btn-primary alignRight ' + ((selectedOffer !== null && (commitmentChoice !== '' || commitments.length === 0)) ? 'bg-color' : '')" @click="saveData()">{{$t('general.next')}}</button>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'offers',
  data () {
    return {
      options: this.$store.state.config.options,
      currency: this.$store.state.config.mainconfig.currency,
      selectedOffer: null,
      commitmentChoice: this.$store.state.config.defaultCommitment
    };
  },
  activated: function () {
    // On s'assure que l'on a pas déjà choisi une offre pour le membre (pour ne pas écraser son choix
    if (this.$store.state.form.resultJson.offer.commitmentChoice === undefined) {
      this.commitmentChoice = this.$store.state.config.defaultCommitment;
    }
  },
  updated: function () {
    // Vérifie si les champs obligatoires ont bien été remplis
    this.$store.dispatch('form/FORM_AUTHORIZENEXTSTEP', {layout: 'Offers', isAuthorized: (this.selectedOffer !== null && (this.commitmentChoice !== '' || this.commitments.length === 0)), data: this.configureData()});
    // Appel de la fonction selectOffer pour vérifier si l'offre sélectionnée est toujours comptatible avec l'engagement sélectionné
    this.selectOffer(this.selectedOffer);
  },
  methods: {
    selectOffer: function (offer) {
      if (offer !== null) {
        if (this.getInitialPrice(offer) && this.getRecurrentPrice(offer)) {
          this.selectedOffer = offer;
        } else if (offer === this.selectedOffer) {
          this.selectedOffer = null;
        }
      }
    },
    configureData: function () {
      if (this.selectedOffer && (this.commitmentChoice !== '' || this.commitments.length === 0 || this.commitments.length === 1)) {
        // On fais une copie de l'objet et on modifie le prix et l'engagement selon la config et le choix
        let returnOffer = {...this.selectedOffer};
        returnOffer.initialPrice = this.getInitialPrice(this.selectedOffer);
        returnOffer.recurrentPrice = this.getRecurrentPrice(this.selectedOffer);
        let tempOption = [];
        returnOffer.options.forEach(function (option) {
          tempOption.push({...option});
          if (this.commitments.length > 0) {
            tempOption[tempOption.length - 1].price = option.price[this.commitmentChoice];
          } else {
            tempOption[tempOption.length - 1].price = option.price[Object.keys(option.price)[0]];
          }
        }, this);
        returnOffer.options = tempOption;
        if (this.commitments.length > 0) {
          delete returnOffer.commitment;
          return {offer: {selectedOffer: returnOffer, commitmentChoice: this.commitmentChoice}};
        } else {
          return {offer: {selectedOffer: returnOffer}};
        }
      }
    },
    saveData: function () {
      if (this.selectedOffer !== null && (this.commitmentChoice !== '' || this.commitments.length === 0 || this.commitments.length === 1)) {
        this.$store.dispatch('form/FORM_NEXTLAYOUT', this.configureData());
      }
    },
    returnOptionOrFalse: function (id) {
      let name = false;
      this.options.forEach(function (option) {
        if (option.id === id) {
          name = option.name;
        }
      });
      return name;
    },
    getInitialPrice: function (offer) {
      if (this.commitments.length > 1) {
        return offer.initialPrice[this.commitmentChoice];
      } else if (this.commitments.length === 1) {
        return offer.initialPrice[this.commitments[0].duration];
      } else {
        return offer.initialPrice[Object.keys(offer.initialPrice)[0]];
      }
    },
    getRecurrentPrice: function (offer) {
      if (this.commitments.length > 1) {
        return offer.recurrentPrice[this.commitmentChoice];
      } else if (this.commitments.length === 1) {
        return offer.recurrentPrice[this.commitments[0].duration];
      } else {
        return offer.recurrentPrice[Object.keys(offer.recurrentPrice)[0]];
      }
    },
    getPeriodTranslation (period, duration) {
      let translatedPeriod = '';
      switch (period) {
        case 'week':
          translatedPeriod = this.$tc('config.commitments.week', (duration > 1) ? 2 : 1);
          break;
        case 'month':
          translatedPeriod = this.$t('config.commitments.month', (duration > 1) ? 2 : 1);
          break;
        case 'year':
          translatedPeriod = this.$tc('config.commitments.year', (duration > 1) ? 2 : 1);
          break;
      }
      return translatedPeriod;
    }
  },
  computed: {
    offers: function () {
      return this.$store.state.config.offers;
    },
    commitments: function () {
      return this.$store.state.config.commitments;
    }

  }
};
</script>

<style scoped>
.inactive {
  color : grey;
}
.active {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/layouts/Offers.vue